import { templateStore } from '../template/index.js';

/**
 * Display video categories in the container
 * @param {HTMLElement} container - Results container
 * @param {Array} categories - Array of category objects
 */
export async function displayVideoCategories(container, categories) {
	if (!container) return;

	const emptyTemplate = templateStore.get('video-category/empty.ejs');
	const listTemplate = templateStore.get('video-category/list.ejs');
	const itemTemplate = templateStore.get('video-category/item.ejs');

	if (!categories || categories.length === 0) {
		// eslint-disable-next-line no-undef
		container.innerHTML = ejs.render(emptyTemplate);
		return;
	}

	// eslint-disable-next-line no-undef
	container.innerHTML = ejs.render(listTemplate, { categories, itemTemplate });
}

/**
 * Render loading state
 * @param {HTMLElement} container - Results container
 */
export function renderLoading(container) {
	if (!container) return;

	container.innerHTML = `
		<div class="flex items-center flex-col text-sm text-gray-900 gap-2 font-medium justify-center p-6 w-full h-full min-h-[300px]">
			<div class="w-8 h-8 border-3 border-primary-100 border-t-primary-500 rounded-full animate-spin"></div>
			${wpcore.direct_t({ en: 'Loading categories...', fr: 'Chargement des catégories...' })}
		</div>
	`;
}
